/**
 * Merchant information display component
 * Shows merchant details with loading and error states
 */

import { Skeleton } from '@/components/common/Skeleton'
import type { MerchantData } from '@/types'

interface MerchantInfoProps {
  merchant: MerchantData | null
  isLoading: boolean
  error: Error | null
}

export function MerchantInfo({ merchant, isLoading, error }: MerchantInfoProps) {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
        <Skeleton lines={3} />
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-error-50 border border-error-200 rounded-lg p-4 mb-6">
        <p className="text-error-700 text-sm">{error.message || 'Failed to load merchant information'}</p>
      </div>
    )
  }

  if (!merchant) {
    return null
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-2xl font-extrabold text-gray-900 text-center capitalize">{merchant.name}</h2>
    </div>
  )
}

